module.exports = __webpack_public_path__ + "img/Icon_No_Contacts.f85796c.svg";